import { Component, OnInit, ChangeDetectionStrategy, Input, ElementRef, ViewChild } from '@angular/core';
import { NotificacionEntry } from 'src/app/shared/entrys/notificacion.entry';
import { ModalGenericoModel } from 'src/app/shared/models/modal.model';

@Component({
	selector: 'app-modal-correo-mensaje',
	templateUrl: './modal-correo-mensaje.component.html',
	styleUrls: ['./modal-correo-mensaje.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalCorreoMensajeComponent implements OnInit {
	@Input()
	notificacion: NotificacionEntry;
	@ViewChild('mensaje', { static: true })
	mensaje: ElementRef;

	modalGenerico: ModalGenericoModel;
	constructor() { }

	ngOnInit() {
		if (!this.notificacion.contenido_mensaje || this.notificacion.contenido_mensaje === 'NULL') {
			this.mensaje.nativeElement.innerHTML = '<p>Sin datos relacionados</p>';
		} else {
			// this.mensaje.nativeElement.innerHTML = this.notificacion.contenido_mensaje.substr(1, this.notificacion.contenido_mensaje.length - 2);
			this.mensaje.nativeElement.innerHTML = this.notificacion.contenido_mensaje;
		}
		this.modalGenerico = {
			titulo: 'Notificación enviada'
		};
	}

}
